import './ReportCP_Diffs.scss';
import colors from "../../../assets/scss/variable/color.scss";
import React, {useState, useRef} from "react";
import T from "../../../shared/component/t/T";
import Storage from "../../../helpers/Storage";
import Modal from "../../../shared/component/Modal/Modal";
import {StringDiff, DiffMethod} from "react-string-diff";
import snippets from "../../../helpers/snippets";
import {connect} from "react-redux";
import {withRouter} from "../../../helpers/withRouter";
import {Tour } from 'antd';
import Button from "../../../shared/component/button/Button";

const ReportCP_Diffs = (props) => {
    const [language] = useState(props.language)
    const [modalShow, setModalShow] = useState(props.show);

    const [current, setCurrent] = useState(props.new)
    const [prev, setPrev] = useState(props.old)

    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);

    const [open, setOpen] = useState(false);

    const steps = [
        {
            title: 'پنجره نمایش تغییرات',
            description: 'اگر در گزارش تغییراتی داده باشید، در این پنجره نمایش داده خواهد شد'+
                ' تغییرات به این صورت اند که قسمت‌های قرمز رنگ به معنی مقادیری است که برای این بیمار ذخیره شده‌اند ' +
                ' و قسمت های سبز رنگ نیز به معنی قمست‌هایی که اکنون آنها را تغییر داده‌اید.' +
                ' همچنین قسمت های خاکستری رنگ هم به معنی عدم تغییر است.'+
                " این پنجره شامل دو قسمت است که در قسمت بالا تغییرات دست اندکاران را نمایش می‌دهد"+
                " و در قسمت پایین نیز تغییرات در قسمت گزارش که شامل عنوان، یافته‌ها و نتیجه نهایی گزارش است"+
                " هر یک از این پنجره‌ها بسته به اینکه تغییراتی در آن قسمت اعمال شده باشد یا نه نمایش داده خواهند شد",
            target: () => ref1.current,
            cover: (
                <img
                    alt=""
                    src="/common/img/diffs_whole.png"
                />
            ),
        },
        {
            title: 'قسمت دست اندرکاران',
            description: 'در این قسمت تغییرات مربوط به دست اندکاران گزارش نمایش داده شده اند که در هر سطر قسمت سبز کاربری است که شما اکنون آنراانتخاب کرده اید و قسمت قرمز رنگ کاربری است که قبلا برای آن بخش ذخیره شده' +
                'همانطور که در این قسمت می بینید، قبلا در قسمت دستیار گزارش «doc» را انتخاب شده بوده در حالیکه در این تغییر، آنرا به «قبادی» تغییر داده است.',
            target: () => ref2.current,
            cover: (
                <img
                    alt=""
                    src="/common/img/diffs_owners.png"
                />
            ),
        },
        {
            title: 'قسمت مشروح گزارش',
            description: 'ممکن است این قسمت برای شما نمایش داده نشود، بنابراین شما در سه قسمت مشروح گزارش یعنی قسمت های عنوان گزارش، یافته‌ها و یا نتیجه نهایی تغییراتی اعمال نکرده‌اید' +
                'در قسمت یافته ها مطابق عکس، کاربر جاری «متن یافته ها» را بدون تغییر گذاشته ولی کلمه «قبلی» را که قرمز رنگ است حذف و به جای آن کلمه «جدید» را جایگزین کرده است',
            target: () => ref3.current,
            cover: (
                <img
                    alt=""
                    src="/common/img/diffs_describale.png"
                />
            ),
        },
    ];

    const onClose=()=>{
        setModalShow(false)
        props.onClose()
    }

    const applyChanges = () =>{
        props.applyChanges()
    }

    const DiffViewer = (before, after) => {
        // https://github.com/elv1n/react-string-diff?tab=readme-ov-file
        const newStyle = {
            added: {
                // backgroundColor: "lightgreen",
                backgroundColor: colors.sendToHIS,
                color: colors.black
            },
            removed: {
                // backgroundColor: 'salmon'
                backgroundColor: colors.redLight,
                color: colors.white
            },
            default: {}
        };

        return <StringDiff className={`diffs ${current.direction}`}
                                    oldValue={before}
                                    newValue={after}
                                    method={DiffMethod.Words}
                                    styles={newStyle}
                />
    }

    const handleShow = (before, after) => {
        return (!snippets.isObjectEmpty(before) || !snippets.isObjectEmpty(after)) && (before !== after)
    }

    const returnUserName = (id) => {
        return id ? Storage.getUserDisplayName(id) : <T token={"not_selected"} />
    }

    const diffsOnOwners = () => {
        let reps = {typist_id: "typist",
            reporter_id: "assistant_1",
            resident2_id: "assistant_2",
            verifier_id: "staff"}

        let res = Object.entries(reps).filter(([item]) => prev[item] !== current[item])

        if (!snippets.isObjectEmpty(res)) {
            return <div className={"diffs_with_reporters"}>
                <div className={"diffs_with_reporters_title"} >
                    <T token={"owner_changes"}/>
                </div>

                <table className={"diffs_with_reporters_tbl"} ref={ref2}>
                    <thead>
                    <tr>
                        <th><T token={"role"}/></th>
                        <th className={"diffs_with_reporters_source"}><T token={"first_values"}/></th>
                        <th className={"diffs_with_reporters_user"}><T token={"new_values"}/></th>
                    </tr>
                    </thead>
                    <tbody>
                    {res.map(([key, value], index) => {
                        return <tr key={index}>
                            <td className={"diffs_with_reporters_name"}> <T token={value}/></td>
                            <td className={"diffs_with_reporters_source"}> {returnUserName(prev[key])} </td>
                            <td className={"diffs_with_reporters_user"}> {returnUserName(current[key])} </td>
                        </tr>})
                    }
                </tbody>
            </table>

            <hr/>

        </div>
        }
    }

    const diffsOnFindings = () => {
        let diffs = ["description_name", "findings", "impression"].filter(item =>
            handleShow(prev[item], current[item])
        )
        if (!snippets.isObjectEmpty(diffs)) {
            return <div className={"diffs_with_describable"} ref={ref3}>

                <div className={"diffs_with_describable_title"} >
                    <T token={"describable_changes"} />
                </div>

                {diffs.map(item => {
                    return showDescribableItem(item, prev[item], current[item])
                })}
            </div>
        }
    }

    const showDescribableItem = (key, prev, current) => {
        return <div className={`diffs_on_${key}`} key={key}>
                <div className={`diff_title`}>
                    <T token={`${key}_changes`} />
                </div>
                <div className={"diff_diffs"}>
                    {DiffViewer(prev, current)}
                </div>
            </div>
    }


    return (
        <>
            <Modal className="ModalReportsDiff"
                show={modalShow}
                closeModal={() => onClose()}
                title=''
                closeable={false}
            >
                <div className={'diffs__wholes'} ref={ref1}>
                    <div className={"diffs__HELP"} onClick={()=>setOpen(true)}>
                        <i className={"fal fa-question-circle fa-xl"} />
                    </div>
                    <div className={"diffs__body"}>

                        {diffsOnOwners()}

                        {diffsOnFindings()}

                    </div>

                    <div className={'__body'} >
                        <div className={'imodal__action'}>
                            {/*<div className={'imodal__btn imodal__btn--primary'}*/}
                            {/*     onClick={applyChanges}*/}
                            {/*>*/}
                            {/*    <T token={'apply_changes'} />*/}
                            {/*</div>*/}

                            <Button {...props.button?.proppedValues} onClick={applyChanges} />

                            <div className={'imodal__btn imodal__btn--secondary'}
                                onClick={() => onClose()}
                            >
                                <T token={'cancel'} />
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <Tour open={open}
                  onClose={() => setOpen(false)}
                  steps={steps}
                  zIndex={100001}
                  scrollIntoViewOptions={true}
                  placement={"left"}
            />
        </>
    )
}

const mapStateToProps = state => {
    const language = state.LangReducer.language;
    return { language };
};

export default connect(mapStateToProps)(withRouter(ReportCP_Diffs));